
require('./bootstrap')

require('./globais')

require('./filters')

import './acl'

import store from './store'

import router from './routes'

import Acl from './acl'
import canDirective from './directives/can'

import { startAdminSessionKeepAlive } from './sessionKeepAlive'

Vue.directive('can', canDirective)

Vue.prototype.$can = (r) => Acl.can(r)

Acl.setUser(window.Laravel && window.Laravel.user ? window.Laravel.user : null)

startAdminSessionKeepAlive()

const app = new Vue({

  el: '#app',

  router,

  store,

  data() {
    return {
      // pagina_atual : this.$route.meta.title || 'Pagamentos' 
      carregando: true
    }
  },

  async mounted() {

    this.carregado()
  },

  methods: {
    carregado() {
      this.carregando = false
    },

    // Método para logout
    async fazerLogout() {
      await this.$store.dispatch('logout')
    },

    //fechar menu do botstrap
    menuClique(title) {
      $(".navbar-collapse").collapse('hide');
    },

    isActive(title) {
      const currentTitle = (this.$route.meta && this.$route.meta.title) || ''
      const currentPath = this.$route.path || ''

      if (title === 'Configurações') {
        return currentPath.startsWith('/config-integracoes')
          || currentPath.startsWith('/admin/assinaturas')
          || currentPath.startsWith('/configs')
      }

      if (title === 'Integrações') {
        return currentPath.startsWith('/config-integracoes')
      }

      if (title === 'Formas de Pagamento' || title === 'Gateway de Assinaturas') {
        return currentPath.startsWith('/admin/assinaturas')
      }

      if (title === 'Relatórios') {
        return currentPath.startsWith('/relatorio-usuarios')
          || currentPath.startsWith('/relatorios/envios-whatsapp')
          || currentPath.startsWith('/pagamentos')
          || currentPath.startsWith('/monitoramento-pagamentos')
          || currentPath.startsWith('/pagamentos-em-aberto')
          || currentPath.startsWith('/cancelamentos')
          || currentPath.startsWith('/onboarding-insights')
          || currentPath.startsWith('/avaliacoes')
      }

      return currentTitle === title
    }
  }



})
